import css from 'styled-jsx/css';

const styles = css.global`footer{height:5.2631578947rem;width:100%;background:var(--primary-gray);display:flex;align-items:center;justify-content:center;margin-top:1.5789473684rem}`;

export default styles;